var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4718 8.84444C20.804 8.92764 21.0531 9.09404 21.1362 9.42683C21.2192 9.67643 21.1362 10.0092 20.887 10.1756L17.0667 13.9196L17.9803 19.2443C18.0633 19.5771 17.8972 19.9098 17.6481 20.0762C17.482 20.1594 17.3159 20.2426 17.1498 20.2426H16.7345L12.0007 17.7467L7.26679 20.2426C6.93459 20.409 6.60239 20.3258 6.35324 20.1594C6.10409 19.993 5.93799 19.6603 6.02104 19.3275L6.93459 14.0028L3.11428 10.2588C2.86513 10.0924 2.78208 9.75962 2.86513 9.42683C3.03123 9.09404 3.28038 8.84444 3.61258 8.84444L8.84474 8.01245L11.2532 3.27014C11.5023 2.68775 12.499 2.68775 12.7481 3.27014L15.1566 8.09565L20.4718 8.84444ZM15.3227 13.8364C15.3227 13.5868 15.4057 13.3372 15.5718 13.0876L18.5616 10.1756L14.4922 9.59323C14.16 9.59323 13.9108 9.42683 13.8278 9.17723L12.0007 5.5165L10.1735 9.26043C10.0074 9.42683 9.7583 9.67643 9.50914 9.67643L5.43968 10.2588L8.42949 13.0876C8.59559 13.3372 8.67864 13.5868 8.67864 13.8364L7.93119 17.9131L11.5854 15.9995C11.8346 15.8331 12.0837 15.8331 12.3329 15.9995L15.9871 17.9131L15.3227 13.8364Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.93c39046.svg";
export { ForwardRef as ReactComponent };